import type { ApiGradFairInviteId, ApiOrgId } from '#/api/types/ApiTypedId';
import type { OrgDashboardGradFairsApiInvite } from '#/modules/orgDashboard/gradFairs/api/types/OrgDashboardGradFairsApiInvite';
import type { OrgDashboardGradFairsApiInviteLocation } from '#/modules/orgDashboard/gradFairs/api/types/OrgDashboardGradFairsApiInviteLocation';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  invite: OrgDashboardGradFairsApiInvite;
  location: OrgDashboardGradFairsApiInviteLocation;
  fairCredits: number;
};

function mapResponse(response: ApiResponse) {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId, inviteId: ApiGradFairInviteId) =>
    `/data/orgdashboard/${orgId}/grad-fair-invites/${inviteId}`,
  mapResponse,
});

// Exports

export const orgDashboardGradFairsApiIsomorphicFetchInvite =
  endpoint.createIsomorphicFetchFn();
